exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-body {\n  overflow-x: unset;\n}\n.header-fixed .app-header {\n  z-index: 1021;\n}\n.sidenav-sticky {\n  top: 68px;\n}\n", ""]);

// exports
